import { z } from 'zod';
import { IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
/**
 * NotificationDedup — survives dispatcher restart per T1-003A design review.
 * Composite unique key on (eventType, recipientUserEmailHash, affectedId,
 * windowStartUnix); the dispatcher (T1-004) claims a window with a single
 * INSERT-on-conflict-skip.
 */
export const NotificationDedupSchema = z.object({
    id: IDSchema,
    type: z.literal('notification_dedup'),
    schemaVersion: SchemaVersionSchema,
    eventType: z.string(),
    /** sha256 hash of the recipient user-email — never the raw address. */
    recipientUserEmailHash: z.string(),
    affectedId: z.string(),
    /** Unix-second floor of the dedup window's start time. */
    windowStartUnix: z.number().int().nonnegative(),
    expiresAt: IsoTimestampSchema,
    createdAt: IsoTimestampSchema,
    updatedAt: IsoTimestampSchema,
    version: z.number().int().positive(),
});
//# sourceMappingURL=notification-dedup.js.map